import type { Clock as ClockType } from "src/types/matchControl/clock";
import type { Contestant as ContestantType } from "src/types/matchControl/contestant";

import Clock from "./Clock";
import Contestant from "./Contestant";
import styles from "./RundownMatchControl.module.scss";

type RugbyProps = {
	handleClickMedia: (contestant: ContestantType, index: number) => void;
	handleChangeContestant: (contestant: ContestantType, index: number) => void;
	handleChangeClock: (clock: ClockType, index: number) => void;
	contestants: ContestantType[];
	clocks: ClockType[];
};

const Rugby = ({
	clocks,
	contestants,
	handleChangeContestant,
	handleChangeClock,
	handleClickMedia,
}: RugbyProps) => (
	<div className={styles.SportContainer}>
		<div className={styles.Contestants}>
			{contestants?.map((contestant, idx) => (
				<Contestant
					key={idx}
					sport="rugby"
					contestant={contestant}
					handleChangeContestant={(contestant) => handleChangeContestant(contestant, idx)}
					handleClickMedia={(contestant) => handleClickMedia(contestant, idx)}
					inverted={idx % 2 === 1}
				/>
			))}
		</div>
		<div className={styles.Clocks}>
			{clocks?.map((clock, idx) => (
				<div key={idx}>
					<Clock clock={clock} handleChangeClock={(clock) => handleChangeClock(clock, idx)} />
				</div>
			))}
		</div>
	</div>
);

export default Rugby;
